import { render, staticRenderFns } from "./markDownText.vue?vue&type=template&id=2427bc86&scoped=true"
import script from "./markDownText.vue?vue&type=script&lang=js"
export * from "./markDownText.vue?vue&type=script&lang=js"
import style0 from "./markDownText.vue?vue&type=style&index=0&id=2427bc86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427bc86",
  null
  
)

export default component.exports